// src/components/popups/WalletActivationAwarenessPopup.js

import React from 'react';

import './WalletActivationAwarenessPopup.css';

import walletIcon from '../../assets/wallet-icon.png';
import piIcon from '../../assets/pi-icon.png';
import securedIcon from '../../assets/secured-icon.png';
import unlockedIcon from '../../assets/unlocked-icon.png';

function WalletActivationAwarenessPopup({
  open,
  amount = 0.1,
  loading = false,
  errorMessage = '',
  successMessage = '',
  onActivate,
  onPassed,
}) {
  if (!open) {
    return null;
  }

  const handleActivate = () => {
    if (loading) return;

    onActivate?.();
  };

  const handlePass = () => {
    if (loading) return;

    onPassed?.();
  };

  return (
    <div className="wallet-awareness-popup-backdrop">
      <div
        className="wallet-awareness-popup-sheet"
        onClick={(event) =>
          event.stopPropagation()
        }
      >
        {errorMessage && (
          <div className="wallet-awareness-popup-banner error">
            {errorMessage}
          </div>
        )}

        {successMessage && (
          <div className="wallet-awareness-popup-banner success">
            {successMessage}
          </div>
        )}

        <div className="wallet-awareness-popup-bg-shape wallet-awareness-popup-bg-shape--top" />

        <div className="wallet-awareness-popup-bg-shape wallet-awareness-popup-bg-shape--bottom" />

        <div className="wallet-awareness-popup-inner">
          <div className="wallet-awareness-popup-top">
            <div className="wallet-awareness-popup-visual">
              <div className="wallet-awareness-popup-orbit wallet-awareness-popup-orbit--one" />

              <div className="wallet-awareness-popup-orbit wallet-awareness-popup-orbit--two" />

              <div className="wallet-awareness-popup-wallet-card">
                <div className="wallet-awareness-popup-wallet-glow" />

                <img
                  src={walletIcon}
                  alt=""
                  className="wallet-awareness-popup-wallet-icon"
                />

                <div className="wallet-awareness-popup-wallet-label">
                  BarterFi Wallet
                </div>
              </div>

              <div className="wallet-awareness-popup-floating-icon wallet-awareness-popup-floating-icon--pi">
                <img src={piIcon} alt="Pi" />
              </div>

              <div className="wallet-awareness-popup-floating-icon wallet-awareness-popup-floating-icon--secure">
                <img
                  src={securedIcon}
                  alt="Secure"
                />
              </div>

              <div className="wallet-awareness-popup-floating-icon wallet-awareness-popup-floating-icon--unlock">
                <img
                  src={unlockedIcon}
                  alt="Unlocked"
                />
              </div>
            </div>

            <h2 className="wallet-awareness-popup-title">
              Activate your
              <br />
              BarterFi Wallet
            </h2>

            <p className="wallet-awareness-popup-subtitle">
              Add Pi once and unlock faster
              payments across BarterFi.
            </p>
          </div>

          <div className="wallet-awareness-popup-middle">
            <div className="wallet-awareness-popup-amount-card">
              <div className="wallet-awareness-popup-amount-label">
                Activation amount
              </div>

              <div className="wallet-awareness-popup-amount-value">
                <img src={piIcon} alt="" />

                <span>{amount} Pi</span>
              </div>

              <p className="wallet-awareness-popup-amount-note">
                This is not a fee. Your Pi stays
                available in your BarterFi wallet.
              </p>
            </div>

            <div className="wallet-awareness-popup-features-card">
              <div className="wallet-awareness-popup-feature-item">
                <span className="wallet-awareness-popup-feature-check">
                  ✓
                </span>

                <span>
                  Send and receive tips
                </span>
              </div>

              <div className="wallet-awareness-popup-feature-item">
                <span className="wallet-awareness-popup-feature-check">
                  ✓
                </span>

                <span>
                  Buy styles and profile banners
                </span>
              </div>

              <div className="wallet-awareness-popup-feature-item">
                <span className="wallet-awareness-popup-feature-check">
                  ✓
                </span>

                <span>
                  Use secure BarterFi Escrow
                </span>
              </div>

              <div className="wallet-awareness-popup-feature-item">
                <span className="wallet-awareness-popup-feature-check">
                  ✓
                </span>

                <span>
                  Boost posts and listings
                </span>
              </div>
            </div>
          </div>

          <div className="wallet-awareness-popup-bottom">
            <button
              type="button"
              className="wallet-awareness-popup-primary-btn"
              onClick={handleActivate}
              disabled={loading}
            >
              {loading ? (
                <span className="wallet-awareness-popup-btn-loading">
                  <span className="wallet-awareness-popup-spinner" />

                  Opening Pi Wallet...
                </span>
              ) : (
                `Activate with ${amount} Pi`
              )}
            </button>

            <button
              type="button"
              className="wallet-awareness-popup-pass-btn"
              onClick={handlePass}
              disabled={loading}
            >
              I’ll Pass
            </button>

            <div className="wallet-awareness-popup-footnote">
              Payment approval happens securely
              inside Pi Wallet.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WalletActivationAwarenessPopup;
